export default "__VITE_ASSET__38nJqEZS__";